module.exports = __webpack_public_path__ + "img/16.c0bff2f1.jpg";